import { Component, Input, OnInit } from '@angular/core';
import { FormatService } from '../../core/format.service';
import { NgUserService } from '../../core/ng-user.service';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { BibStyle } from '../../rl-common/shared/shared/types/bib-style';

@Component({
  selector: 'rl-quick-cite-dialog',
  templateUrl: './quick-cite-dialog.component.html',
  styleUrls: ['./quick-cite-dialog.component.scss']
})
export class QuickCiteDialogComponent implements OnInit {

  @Input() citationId : string;
 
  displayCopyButton : boolean = true; 
  styles : BibStyle[];
  style : BibStyle;
  citationText : string;
  lang : string;
  busy : boolean;

  constructor(private formatService : FormatService, private userService : NgUserService, private utilsService : UtilsService) { }

  ngOnInit(): void {
    this.lang = this.userService.user.userPreferredLanguage ? this.userService.user.userPreferredLanguage : 'en';
    this.formatService.bibStylesWithDefault().subscribe((styles : BibStyle[]) => {
      this.styles = styles.filter(s => s.value != 'exlibris');
      let defaultIndex = this.styles.findIndex(s => s.isDefault);
      this.style = this.styles[defaultIndex != -1 ? defaultIndex : 0];      
      
      this.getCitationText();
    });
  }

  getCitationText() : void {
    this.busy = true;
    this.formatService.quickCite(this.citationId, { lang :this.lang, style : this.style.value }).subscribe((cite : string) => {      
      this.citationText = cite;

      // remove the line numbers
      let div = document.createElement("div");
      div.innerHTML = this.citationText;
      let innerDiv = div.firstElementChild;
      let innerDiv2 = innerDiv.firstElementChild;
      if (innerDiv2 && innerDiv2.classList && innerDiv2.classList.contains('csl-left-margin')) {
        innerDiv.removeChild(innerDiv2);
      }

      this.citationText = div.innerHTML;
      this.busy = false;
    });
  }

  copyToClipboard() : void {
    let div = document.createElement("div");
    div.innerHTML = this.citationText;
    let text = div.textContent || div.innerText || "";
    this.utilsService.copyToClipboard(text.trim());
    this.displayCopyButton = false;
  }

  changeStyle() : void {
    this.getCitationText();
    this.displayCopyButton = true;
  }

  close = () : void => {};

}
